import { isMobileOnly, getUA } from 'mobile-device-detect'
// import _ from 'lodash'
export default {
  data () {
    return {
      test: 'test mixin',
      registration: null,
      updateExists: false,
      newversion: {},
      getUA: getUA,
      isMobileOnly: isMobileOnly
    }
   },
  sockets: {
    connect () {
      // console.log('socket to notification channel connected')
      this.$socket.emit('hello', {
        message: 'hi from vue',
        user: this.$store.state.user,
        hotel: this.$store.state.hotels.activehotel,
        getUA: this.getUA
      })
    },
    stream (value) {
      // console.warn(value)
      // this.messagebox('User permissions change', 'you got new permissions for your account.', 'red')
      if (value.title === 'User Update' && value.userid === this.$store.state.user.id) {
        this.$store.dispatch('getUser')
        this.$store.dispatch('hotels/getHotels')
        if (value.hotelid === this.$store.state.hotels.activehotel._id) {
          this.messagebox('User permissions change', 'you got new permissions for your account.', 'green')
        }
      }
      if (value.title === 'Ombrellone Update' && value.hotelid === this.$store.state.hotels.activehotel._id) {
        this.$store.dispatch('ombrelloni/getOmbrelloni')
        this.$store.dispatch('guests/getGuests')
      }
    }
  },
   methods: {
    messagebox (title, message, type) {
      this.$alert(message, title, {
        confirmButtonText: 'OK',
        confirmButtonClass: 'btn ' + type,
        showClose: false,
        type: type,
        customClass: type,
        callback: () => {
          if (!this.$store.state.user.privileges.admin) {
            this.$emit('open', 'dashboard')
          }
          // this.$message({
          //   type: 'info',
          //   message: `action: ${ action }`
          // })
        }
      })
    },
    nothing () {
      console.log('nothing')
    },
    updateAvailable (event) {
      console.log(event)
      this.registration = event.detail
      this.updateExists = true
    },
    refreshApp () {
      console.warn('refreshApp ')
      this.$store.commit('SET_VERSION', this.newversion)
      this.updateExists = false
      // console.warn('RESET_VERSION')
      // this.$store.commit('RESET_VERSION')
      if ('serviceWorker' in navigator) {
        console.log('refreshing serviceWorker')
        // Make sure we only send a 'skip waiting' message if the SW is waiting
        if (!this.registration || !this.registration.waiting) return
        // Send message to SW to skip the waiting and activate the new SW
        this.registration.waiting.postMessage({ type: 'SKIP_WAITING' })
      } else {
        console.log('refreshing app')
        window.location.reload()
      }
      // if (window.webkit === undefined) {
      //   console.warn('RESET_VERSION')
      //   this.$store.commit('RESET_VERSION')
      //   window.location.reload()
      // }
    },
    logout () {
      localStorage.clear()
      this.$router.replace('/login')
    },
    openmenu () {
      // console.log('wer')
      this.$emit('openmenu')
    }
   },
   computed: {
    privileges () {
      // if (this.$store.state.user.id === this.$store.state.hotels.activehotel.user) {
      //   return {
      //     owner: true,
      //     admin: true
      //   }
      // } else if (_.some()) {

      // }
    }
   },
   beforeMount () {
    console.warn('helper')
    if (!this.$store.state.user.privileges.guest) {
      console.log('go')
      this.$store.dispatch('getUser')
      this.$store.dispatch('hotels/getHotels')
      this.$store.dispatch('guests/getPasses')
    } else {
      this.$store.dispatch('beach/getBeach', this.$store.state.hotels.activehotel._id)
    }
    // console.log(this.registration)
    // this.$store.dispatch('ombrelloni/getOmbrelloni')
    // this.$store.dispatch('guests/getGuests')
    // console.log('checking for season and segment sync')
    // _.map(this.$store.state.hotels.activehotel.seasons, function (season) {
    //   // console.log(season.name)
    //   _.map(season.pricelist, function (list) {
    //     _.map(list.segments, function (segment) {
    //       // console.log(season.name, segment.name, segment.segmentid)
    //     })
    //   })
    // })
    // var self = this
    // var sync = _.forEach(this.$store.state.hotels.activehotel.seasons, function (season) {
    //   _.map(season.pricelist, function (listitem) {
    //     // console.log('l: ', listitem.segments)
    //       var differences = _.differenceBy(self.$store.state.hotels.activehotel.segments, listitem.segments, 'name')
    //       var toremove = _.differenceBy(listitem.segments, self.$store.state.hotels.activehotel.segments, 'segmentid')
    //       // console.log(listitem.period, differences, toremove)
    //       // console.log('to add: ', differences)
    //       // console.log('to remove: ', toremove)
    //       if (differences.length > 0) {
    //         _.forEach(differences, (difference) => {
    //           // console.log(listitem.period, difference)
    //           // console.log('to add ', difference.name, season.name)
    //           listitem.segments.push(JSON.parse(JSON.stringify(difference)))
    //         })
    //       }
    //       if (toremove.length > 0) {
    //         _.forEach(toremove, (item) => {
    //           // console.log('remove ', item.name, season.name)
    //           _.remove(listitem.segments, function (segment) {
    //             return segment.segmentid === item.segmentid
    //           })
    //         })
    //       }
    //       return listitem
    //     })
    // })
    // console.log('sync ', sync)
    // this.$store.dispatch('hotels/syncSeasons', sync)
    // var differences = _.differenceBy(self.$store.state.hotels.activehotel.segments, _.map(this.$store.state.hotels.activehotel.seasons, function (season) {
    //   return ._map(season.pricelist, function (list) {
    //     return ._map(list.segments, 'segmentid')
    //   })
    // }), 'name')
    // var toremove = _.differenceBy(listitem.segments, self.$store.state.hotels.activehotel.segments, 'segmentid')
   },
   created () {
    var self = this
    self.$store.dispatch('checkForUpdates').then(data => {
      // console.log('updateExists ', data.updateExists)
      if (data.updateExists) {
        console.log('updateExists ')
        self.updateExists = true
        self.newversion = data.version
      }
    }, error => {
      console.warn(error)
    })
    // console.log('userdidlogin')
    // console.log(window.webkit && (window.webkit !== undefined))
    // console.log('navigator', navigator)
    // setInterval(function(){
    //   console.log('checking for updates1')
    //   self.$store.dispatch('checkForUpdates').then(data => {
    //     // console.log('updateExists ', data.updateExists)
    //     if (data.updateExists) {
    //       console.log('updateExists ')
    //       self.updateExists = true
    //       self.newversion = data.version
    //     }
    //   }, error => {
    //     console.warn(error)
    //   })
    // }, 30000)
    // this.$store.dispatch('checkForUpdates')
    // window.webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify({ 'command': 'userdidlogin', 'data': {'jwt': this.$store.state.jwt.jwt}}))
    // if (window.webkit && window.webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify({ 'command': 'userdidlogin', 'data': {'jwt': this.$store.state.jwt.jwt}}))) {
    if (window.webkit && window.webkit !== undefined) {
      // window.webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify({ 'command': 'userdidlogin', 'data': {'jwt': data.data.jwt}}))
      console.log('in app')
      this.$store.commit('SET_INAPP', true)
    } else {
      console.warn('not in app')
      this.$store.commit('SET_INAPP', false)
    }
    if (this.$store.state.ombrelloni.ombrelloni.length === 0 && this.$store.state.hotels.hotels.length > 0) {
      console.log('no ombrelloni')
      this.$emit('open', 'editgrid')
    }
    if (!this.$store.state.hotels?.activehotel?._id || this.$store.state.hotels.activehotel === undefined ) {
      console.warn('no activehotel')
    }
    // console.log(this.registration)
    if ('serviceWorker' in navigator) {
      document.addEventListener('swUpdated', this.updateAvailable, { once: true })
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        // We'll also need to add 'refreshing' to our data originally set to false.
        if (this.refreshing) return
        this.refreshing = true
        // Here the actual reload of the page occurs
        window.location.reload()
      })
    }
    if (process.env.NODE_ENV === 'production') {
      setInterval(function(){
        // console.log('check for updates')
        if ('serviceWorker' in navigator) {
          document.addEventListener('swUpdated', this.updateAvailable, { once: true })
          navigator.serviceWorker.addEventListener('controllerchange', () => {
            // We'll also need to add 'refreshing' to our data originally set to false.
            if (this.refreshing) return
            this.refreshing = true
            // Here the actual reload of the page occurs
            window.location.reload()
          })
          navigator.serviceWorker.getRegistrations().then(function (registrations) {
            for (let registration of registrations) {
              registration.update()
            }
          })
        } else {
          console.log('checking for updates')
          self.$store.dispatch('checkForUpdates').then(data => {
            // console.log('updateExists ', data.updateExists)
            if (data.updateExists) {
              console.log('updateExists ')
              self.updateExists = true
              self.newversion = data.version
            }
          }, error => {
            console.warn(error)
          })
        }
      }, 300000);
    }
   }
};